import { LocalStorageKey } from 'shared/constants/localStorage'

export const lsRemoveItem = (key: LocalStorageKey) => {
  localStorage.removeItem(key)
}
